import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const MINUTES = 60 * 1000;
const HOURS = 60 * MINUTES;

const queryDefaults = {
  staleTime: 10 * MINUTES,
  cacheTime: 24 * HOURS,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
  keepPreviousData: true,
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: queryDefaults,
  },
});

export const QueryProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <QueryClientProvider client={queryClient}>
    {children}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
